import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { LoggingService } from './services/logging.service';
import { IconSetService } from '@coreui/icons-angular';
import { iconSubset } from './icons/icon-subset';
import { TokenValidationService } from './services/token-validation.service';
import { PendoService } from './services/pendo.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Portal';
  private readonly destroyed$ = new Subject<void>();

  constructor(
    private router: Router,
    private iconSetService: IconSetService,
    private loggingService: LoggingService,
    private tokenValidationService: TokenValidationService,
    private pendoService: PendoService
  ) {
    // iconSet singleton
    iconSetService.icons = { ...iconSubset };
  }

  ngOnInit(): void {
    // Start background token validation service
    this.tokenValidationService.start();
    this.router.events.pipe(takeUntil(this.destroyed$)).subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
    });
  }
  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
